const setAutoHeight = carousel => {
  let timeout

  const autoHeight = () => {
    let height, maxHeight, i
    let itemHeightList = []
    const min = carousel.currentSlide
    const max =  min + carousel.perPage

    for (i = min; i < max; i++) {
      height = parseInt(carousel.innerElements[i].scrollHeight, 10)
      itemHeightList.push(height)
    }

    maxHeight = Math.max.apply(null, itemHeightList)
    carousel.selector.style.maxHeight = maxHeight + 'px'
  }

  window.addEventListener('resize', () => {
    carousel.selector.style.maxHeight = ''
    clearTimeout(timeout)
    timeout = setTimeout(autoHeight, 500)
  })

  autoHeight()
}

export default setAutoHeight
